import { memo } from 'react';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorMessageWrapper = styled.div.withConfig({
  displayName: "CalleeError__ErrorMessageWrapper",
  componentId: "sc-4dzjxe-0"
})(["> div > img{margin-bottom:", ";}"], ({
  theme
}) => `${theme.space['400']}`);
function CalleeError() {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "320px",
    marginInline: "auto",
    children: /*#__PURE__*/_jsx(ErrorMessageWrapper, {
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "errors/general",
        illustrationProps: {
          width: 80
        },
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callSettingsWidget.popoverError.title"
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "400"
          })]
        }),
        paddingInline: "200",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callSettingsWidget.popoverError.body"
        })
      })
    })
  });
}
export default /*#__PURE__*/memo(CalleeError);